'use strict';

var React = require('react');
var ThemeContext = require('./ThemeContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function useTheme() {
  var theme = React__default["default"].useContext(ThemeContext);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default["default"].useDebugValue(theme);
  }

  return theme;
}

module.exports = useTheme;
